import router from "../router"

export default function logout() {
  localStorage.removeItem("access-token")
  localStorage.removeItem("carl-user-email")
  router.push("Login")
}
